import type { IconSvgObject } from './types';

const PackageReceive01Icon: IconSvgObject = [
  ["path", { d: "M2.5 7.5V19.5C2.5 20.6046 3.39543 21.5 4.5 21.5H13.5M21.5 13.5V7.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4.91739 3.47101L2.5 7.5H21.5L19.0826 3.47101C18.7212 2.8686 18.0701 2.5 17.3676 2.5L6.63238 2.5C5.92986 2.5 5.27884 2.8686 4.91739 3.47101Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 7.5V2.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10 10.5H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M15.5 18.5L18.5 21.5L21.5 18.5M18.5 21V14.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default PackageReceive01Icon;
